import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { BulletinMessagesSystem } from '../types';
import AccordionLevel from './AccordionLevel';
import CategoryAccordion, { hasFormErrorInCategory } from './CategoryAccordion';
import { useBulletinMessages } from '../../../../context/bulletin-messages';

export function hasFormErrorInSystem(
  system: BulletinMessagesSystem,
  hasErrors?: Record<string, boolean>,
) {
  if (!hasErrors) {
    return false;
  }
  return Object.keys(hasErrors).some(
    k =>
      (k === system.code && hasErrors[k]) ||
      system.categories.some(c => hasFormErrorInCategory(c, hasErrors)),
  );
}

function SystemAccordion({
  system,
  index,
}: {
  system: BulletinMessagesSystem;
  index: number;
}) {
  const { hasErrors } = useBulletinMessages();
  const error = hasFormErrorInSystem(system, hasErrors);
  return (
    <AccordionLevel
      title={system.name}
      flagLabel="Message on system"
      defaultValue={system.content}
      index={index}
      type="system"
      id={system.code}
      error={error}
    >
      <Accordion defaultActiveKey="0">
        {system.categories.map((category, catIndex) => (
          <CategoryAccordion
            key={category.name}
            category={category}
            index={catIndex}
          />
        ))}
      </Accordion>
    </AccordionLevel>
  );
}

export default SystemAccordion;
